<template>
  <div class="container">
    <a-breadcrumb class="mb14">
      <a-breadcrumb-item>
        <a @click="goBack">抽奖活动管理</a>
      </a-breadcrumb-item>
      <a-breadcrumb-item>编辑</a-breadcrumb-item>
    </a-breadcrumb>
    <a-radio-group
      style="margin-bottom: 14px !important;"
      v-model:value="langCode"
      v-if="langDic && langDic.length"
    >
      <a-radio-button
        v-for="item in langDic"
        :key="item.value"
        :value="item.value"
      >
        {{ item.label }}
      </a-radio-button>
    </a-radio-group>
    <a-form
      ref="formRefValue"
      class="active-form"
      :model="formState"
      :rules="rules"
      layout="vertical"
    >
      <a-form-item label="活动类型" name="activityType" required class="w300">
        <a-select
          :disabled="isEdit || notDefaultLang"
          v-model:value="formState.activityType"
        >
          <a-select-option :value="1">转盘</a-select-option>
          <a-select-option :value="2">刮刮乐</a-select-option>
          <a-select-option :value="3">盲盒</a-select-option>
          <a-select-option :value="4">卡牌</a-select-option>
        </a-select>
      </a-form-item>
      <span v-for="(item, index) in formState.langs" :key="index">
        <a-form-item
          label="活动名称"
          :name="['langs', index, 'activityName']"
          :rules="rules.activityName"
          v-if="item.langCode === langCode"
        >
          <a-input
            v-model:value="item.activityName"
            class="w300"
            placeholder="请输入"
            :disabled="isEdit"
          />
        </a-form-item>
      </span>
      <a-form-item name="time">
        <template #label>
          <div>
            <span>活动时间</span>
            <small>（请输入GMT+1时间）</small>
          </div>
        </template>
        <a-range-picker
          v-model:value="formState.time"
          :format="formatDate"
          :placeholder="['开始时间', '结束时间']"
          :show-time="{
            defaultValue: [
              moment('00:00:00', 'HH:mm:ss'),
              moment('23:59:59', 'HH:mm:ss')
            ]
          }"
          :disabled="isEdit || notDefaultLang"
          :disabled-date="disabledDate"
          @change="handleTimeChange"
        />
      </a-form-item>
      <span v-for="(item, index) in formState.langs" :key="index">
        <a-form-item
          label="活动规则"
          :name="['langs', index, 'activityRule']"
          :rules="rules.activityRule"
          v-if="item.langCode === langCode"
        >
          <quillEditor
            v-model:value="item.activityRule"
            style="height: 100px;"
            :options="editorOption"
            :disabled="isEdit"
          />
        </a-form-item>
      </span>
      <a-form-item
        label="可参与人群"
        name="participants"
        v-if="formState.activityType === 1"
      >
        <a-radio-group
          v-model:value="formState.participants"
          :disabled="isEdit"
        >
          <a-radio :value="0">全部用户</a-radio>
          <a-radio :value="1">已登录用户</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="单个用户活动参与次数上限" name="joinLimit">
        <div class="df aic">
          <template v-if="formState.joinLimit === -1">
            <a-input-number :disabled="true" />
          </template>
          <template v-else>
            <a-input-number
              v-model:value="formState.joinLimit"
              placeholder="请输入"
              :disabled="checked || isEdit || notDefaultLang"
              :min="0"
            />
          </template>
          <a-form-item style="margin-bottom: 0;">
            <a-checkbox
              v-model:checked="checked"
              :disabled="isEdit || notDefaultLang"
              @change="changeLimiet"
              class="ml10"
            >
              不限
            </a-checkbox>
          </a-form-item>
        </div>
      </a-form-item>
      <a-form-item
        label="活动参与次数每日计算起始时间"
        name="lotteryChanceExpire"
      >
        <div class="df aic">
          <span class="mr4"> GMT+1</span>
          <a-input-number
            v-model:value="formState.lotteryChanceExpire"
            placeholder="请输入"
            :disabled="isEdit || notDefaultLang"
            :min="0"
            :max="23"
          />
          <span class="ml4">时</span>
          <!-- <a-checkbox class="ml4">不失效</a-checkbox> -->
        </div>
      </a-form-item>
    </a-form>
    <div class="awards">
      <h3>
        <span>奖项设置</span>
        <span class="tips">
          启用的奖项数量需为2的整数倍，建议4-8个
        </span>
      </h3>
      <AddAwards />
    </div>
    <div class="awards">
      <h3>
        获取方式设置
      </h3>
      <AddType />
    </div>
  </div>
  <div class="footer">
    <a-button @click="goBack">取消</a-button>
    <a-button class="ml16" type="primary" :disabled="isEdit" @click="onSvae"
      >保存</a-button
    >
  </div>
</template>

<script>
import { computed, provide, reactive, toRefs, onMounted, watch } from 'vue'
import { quillEditor } from 'vue3-quill'
import AddAwards from './components/AddAwards.vue'
import AddType from './components/AddType.vue'
import {
  lottery_activity_save,
  lottery_activity_detail
} from '@/server/modules/8199.js'
import { useRoute, useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import moment from 'moment'
import dayjs from 'dayjs'
import useAPI from 'UseApi'

const { common_lang_get_ } = useAPI(null, [3426])

const rules = {
  activityName: [
    { required: true, trigger: 'blur', message: '请输入活动名称' }
  ],
  time: [{ required: true, trigger: 'change', message: '请选择活动时间' }],
  activityRule: [
    { required: true, trigger: 'change', message: '请输入活动规则' }
  ],
  joinLimit: [
    {
      required: true,
      trigger: 'blur',
      message: '请输单个用户活动参与次数上限'
    }
  ],
  lotteryChanceExpire: [
    {
      required: true,
      trigger: 'change',
      message: '请输入活动参与次数每日失效时间配置'
    }
  ],
  dailyExchangeLimit: [
    { required: true, trigger: 'change', message: '请输入兑换上限' }
  ],
  participants: [
    { required: true, trigger: 'change', message: '请选择可参与人数' }
  ]
}

export default {
  name: 'AddActive',
  components: { AddAwards, AddType, quillEditor },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const state = reactive({
      formState: {
        activityType: 1,
        lotteryChanceObtainedWayDTOList: [],
        lotteryPrizeDTOList: [],
        startTime: '',
        endTime: '',
        brandId: route.query.brandId || 1,
        siteId: route.query.siteId || 1,
        channelId: route.query.channelId || 1,
        time: [],
        langs: []
      },
      activityId: '',
      formRefValue: null,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      rules,
      status: route.query.status || '',

      checked: false,
      formatDate: 'YYYY-MM-DD HH:mm:ss',
      editorOption: {
        placeholder: '输入',
        modules: {
          toolbar: [
            [
              {
                font: [
                  'Muli-Light',
                  'Muli-SemiBold',
                  'Muli-Bold',
                  'Muli-ExtraBold'
                ]
              }
            ],
            [
              {
                size: [
                  '12px',
                  '14px',
                  '16px',
                  '18px',
                  '20px',
                  '22px',
                  '24px',
                  '26px',
                  '28px',
                  '30px',
                  '32px',
                  '34px',
                  '36px',
                  '38px',
                  '40px'
                ]
              }
            ],
            ['bold', 'link'],
            [
              {
                color: [
                  'red',
                  'blue',
                  'green',
                  'black',
                  'yellow',
                  'pink',
                  'white',
                  '#14AA6E'
                ]
              }
            ]
          ]
        }
      },
      editorOption1: {
        placeholder: '输入',
        modules: {
          toolbar: [
            ['underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ['clean'],
            ['link', 'image']
          ]
        }
      },
      langCode: '',
      langDic: [],
      defaultLanguageCode: '',
      defaultLanguageIndex: 0,
      /**
       *
       * @param {Array} list 一般为多语言langs字段
       * @param {Object} multilingual 初始化数据
       * @param {Object} formState 需要回填的默认外层数据, 如没有默认取 multilingual
       * @param {Array} [langList=state?.langDic || "[{ value: 0 }]"] 站点的多语言数组 格式为 langDic<{value, label}>, 一般为state?.langDic， 已内置
       * @param {string} [defaultLanguageCode=state?.defaultLanguageCode || 0] 默认语言， 一般为state.defaultLanguageCode, 已内置
       * @example langs = handleLangsLack(langs, resetFormState, formState)
       */
      handleLangsLack(
        list,
        multilingual,
        formState,
        langList = state?.langDic,
        defaultLanguageCode = state?.defaultLanguageCode
      ) {
        if (!list?.length) list = []
        if (!langList?.length) langList = [{ value: 0 }]
        if (!defaultLanguageCode) defaultLanguageCode = 0
        if (!formState) formState = multilingual
        // 返回的是 数组， 如果传过来的list里面有langCode并且在langDic中能查找到，返回list的index, 如果找的到用接口返回数据合并原数据， 找不到则用原始数据
        return langList.map(v => {
          const index = list.findIndex(k => v.value === k?.langCode)
          if (v?.value === defaultLanguageCode)
            return { ...formState, ...list[index], langCode: v.value }
          return index > -1
            ? { ...multilingual, ...list[index], langCode: v.value }
            : { ...multilingual, langCode: v.value }
        })
      },
      resetData: form => ({
        activityName: form?.activityName ?? '',
        activityRule: form?.activityRule ?? ''
      }),
      common_lang_get: async () => {
        await common_lang_get_({ ...route?.query }, state)
      },
      notDefaultLang: computed(
        () => state.langCode !== state.defaultLanguageCode
      ),
      isEdit: computed(() => {
        return route.query.activityId && route.query.isEdit === 'view'
      }),
      handleTimeChange(date, dateString) {
        state.formState.startTime = dateString[0]
        state.formState.endTime = dateString[1]
      },
      disabledDate: current => {
        return current && current < moment().subtract(1, 'day')
      },
      goBack() {
        const query = route.query
        router.push({ name: 'List', query: { ...query } })
      },
      changeLimiet() {
        state.formState.joinLimit = state.checked ? -1 : ''
        state.formRefValue.clearValidate(['joinLimit'])
      },
      async getDetails(activityId) {
        try {
          let { success, data, retInfo } = await lottery_activity_detail({
            activityId
          })
          if (success) {
            state.formState = data
            if (data.startTime && data.endTime) {
              state.formState.time = [
                dayjs(data.startTime, state.formatDate),
                dayjs(data.endTime, state.formatDate)
              ]
            }

            state.checked = data.joinLimit === -1
          } else {
            message.error(retInfo)
          }
        } catch (errorInfo) {
          console.log('Failed:', errorInfo)
        }
      },
      async onSvae() {
        try {
          await state.formRefValue.validateFields()

          let flag = true
          for (let v of state.formState?.langs) {
            if (!v.activityName || !v.activityRule) {
              message.error(
                `多语言${
                  state.langDic.find(k => k.value === v.langCode)?.label
                }下${!v.activityName ? '活动名称' : '活动规则'}不能为空`
              )
              flag = false
              break
            }
          }

          if (!flag) throw { flag }

          const params = {
            ...state.formState,
            ...state.formState?.langs?.[state.defaultLanguageIndex]
          }
          let { success, retInfo } = await lottery_activity_save(params)
          if (success) {
            message.success('保存成功！')
            state.goBack()
          } else {
            message.error(retInfo)
          }
        } catch (errorInfo) {
          console.log('Failed:', errorInfo)
        }
      }
    })

    provide('initData', state)

    onMounted(async () => {
      await state.common_lang_get()
      if (route.query.activityId) {
        await state.getDetails(route.query.activityId)
      } else {
        watch(
          () => JSON.parse(JSON.stringify(state.formState.langs)),
          (n, o) => {
            const currentLangIndex = state.formState.langs.findIndex(
              v => v.langCode === state.langCode
            )
            if (state.langCode === state.defaultLanguageCode) {
              state.formState.langs.forEach(item => {
                if (!item?.notActivityNamefollow) {
                  item.activityName = n[currentLangIndex].activityName
                }
                if (!item?.notActivityRulefollow) {
                  item.activityRule = n[currentLangIndex].activityRule
                }
              })
            } else {
              if (
                n?.[currentLangIndex]?.activityName !==
                  o?.[currentLangIndex]?.activityName &&
                state.langCode
              ) {
                state.formState.langs[
                  currentLangIndex
                ].notActivityNamefollow = true
              }
              if (
                n?.[currentLangIndex]?.activityRule !==
                  o?.[currentLangIndex]?.activityRule &&
                state.langCode
              ) {
                state.formState.langs[
                  currentLangIndex
                ].notActivityRulefollow = true
              }
            }
          },
          {
            deep: true
          }
        )
      }
      state.formState.langs = state.handleLangsLack(
        state.formState.langs,
        state.resetData(),
        state.resetData(state.formState)
      )
    })

    return {
      ...toRefs(state),
      moment
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  background-color: #fff;
  margin: 16px;
  padding: 16px 24px 24px 24px;
}

.tips {
  font-size: 12px;
  padding-left: 16px;
  color: rgba(0, 0, 0, 0.3);
}

::v-deep(.active-form .ant-form-item-label label::after) {
  display: inline-block;
  margin-left: 4px;
  line-height: 1;
  content: ':';
}

.awards {
  margin-top: 16px;

  h3 {
    margin-bottom: 16px;
  }
}
.footer {
  background-color: #fff;
  padding: 16px;
  text-align: right;
}
</style>
